import React from 'react';

import { ARROW_LEFT_ICON } from '../../../../constants/images';
import { useScrollState } from '../../../../hooks/useScrollState/useScrollState';
import { IDetailsHero } from '../../../../interfaces/hero';
import BdsAvatar from '../../BdsAvatar/BdsAvatar';
import BdsIconButton from '../../Buttons/BdsIconButton/BdsIconButton';

import './DetailsHero.scss';

const DetailsHero = ({ title, description, color, icon, backAction }: IDetailsHero) => {
  const isScrolled = useScrollState(0);

  return (
    <>
      <div
        className={`main-hero details-hero flex flex-col justify-start items-start ${color} ${
          isScrolled ? 'shrink' : ''
        } w-full`}
      >
        <div className="icon-back">
          <BdsIconButton action={backAction} size="sm" icon={ARROW_LEFT_ICON} variant="transparent" />
        </div>
        <div className="info-container flex flex-row justify-start items-center w-full">
          <BdsAvatar size="l" src={{ photoUri: icon }} />
          <div className={`bottom flex flex-col w-full ${isScrolled ? 'shrink' : ''}`}>
            <h2 className="title">{title}</h2>
            <div className="bottom-information flex justify-between items-center">
              {!isScrolled && <div className="flex flex-row gap-3">{description}</div>}
            </div>
          </div>
        </div>
      </div>
      <div className={`details-hero-spacer ${isScrolled ? 'shrink' : ''}`} />
    </>
  );
};

export default DetailsHero;
